(function () {
    'use strict';

    angular
        .module('app.password-reset')
        .config(configRoutes);

    configRoutes.$inject = ['$stateProvider', '$urlServiceProvider', 'passwordResetResolver'];
    function configRoutes($stateProvider, $urlServiceProvider, passwordResetResolver) {
        $stateProvider.state('password-reset', {
            url: '/password-reset/:token',
            component: 'sc3PasswordReset',
            resolve: passwordResetResolver,
            params: {
                token: { squash: true, value: null }
            },
            data: {
                allowAnonymous: true
            }
        });
    }
})();